// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MuiTableCell-head {\n  font-weight: 700 !important;\n  background-color: #D8D8D8;\n}", ""]);
// Exports
module.exports = exports;
